import { ViewEventBasketSalt } from '../views/eventBasketSalt';

export default function EventBasketSalt() {
    return <ViewEventBasketSalt />
}